module.exports = __webpack_public_path__ + "img/b-language.4a7cba88.png";